import type { ReactNode } from 'react'
import { cn } from '@app/lib/cn'

/**
 * The saya module's inline messages — one line, one colour, always naming the
 * next move. Shared by the review screen and the upload cards so a warning
 * reads the same wherever the operator meets it.
 */

export function Notice({
  tone,
  icon,
  className,
  children,
}: {
  tone: 'ok' | 'warn' | 'error'
  icon: ReactNode
  className?: string
  children: ReactNode
}) {
  return (
    <div
      role={tone === 'error' ? 'alert' : undefined}
      className={cn(
        'flex items-start gap-1.5 rounded-sm border px-3 py-2 text-data',
        tone === 'ok' && 'border-zeytin/25 bg-zeytin/8 text-zeytin',
        tone === 'warn' && 'border-hardal/30 bg-hardal/10 text-hardal',
        tone === 'error' && 'border-kordovan/25 bg-kordovan/6 text-kordovan',
        '[&_svg]:mt-0.5 [&_svg]:size-3.5 [&_svg]:shrink-0',
        className,
      )}
    >
      {icon}
      <div className="min-w-0">{children}</div>
    </div>
  )
}

/** A failed request, in the sentence the API sent — never a status code. */
export function ErrorNote({ error }: { error: unknown }) {
  return (
    <p
      role="alert"
      className="rounded-xs border border-kordovan/25 bg-kordovan/6 px-2.5 py-1.5 text-data text-kordovan"
    >
      {errorText(error, 'İşlem tamamlanamadı.')}
    </p>
  )
}

export function errorText(error: unknown, fallback: string): string {
  return error instanceof Error && error.message ? error.message : fallback
}
